import axios from 'axios';
import { documentViewerConfig } from './assets/documentViewerConfig';
import _ from 'lodash';
const documentsAxios = axios.create({
    baseURL: documentViewerConfig.documentsApiUrl,
});

export default class APIDocuments {
    static async getDocTypes(signal = null) {
        return new Promise(function (resolve, reject) {
            documentsAxios
                .get(
                    `${documentViewerConfig.documentsApiUrl.endsWith('/') ? documentViewerConfig.documentsApiUrl : documentViewerConfig.documentsApiUrl + '/'}documents/type`,
                    {
                        signal,
                        headers: {
                            autoRefresh: true,
                        },
                    },
                )
                .then(function (response) {
                    if (response.status === 200) {
                        resolve(response.data);
                    } else {
                        resolve(null);
                    }
                })
                .catch(function (error) {
                    reject(error);
                });
        });
    }

    static async getAllDocumentsByCatalogue(catalogId, sort = null, signal = null) {
        return new Promise(function (resolve, reject) {
            axios
                .get(
                    `${documentViewerConfig.documentsApiUrl.endsWith('/') ? documentViewerConfig.documentsApiUrl : documentViewerConfig.documentsApiUrl + '/'}documents/list/${catalogId}`,
                    {
                        signal,
                        mode: 'no-cors',
                        headers: {
                            'Cache-Control': 'no-cache',
                            pragma: 'no-cache',
                            Accept: 'application/json',
                            'Content-Type': 'application/json',
                        },
                    },
                )
                .then(function (response) {
                    if (response.status === 200) {
                        resolve(response.data);
                    } else {
                        resolve(null);
                    }
                })
                .catch(function (error) {
                    reject(error);
                });
        });
    }

    static async uploadDocumentDataXHR(file, metadata = '', progressPrc = null) {
        return new Promise((resolve) => {
            const formData = new FormData();
            formData.append('metadata', metadata);
            formData.append('file', file);
            const xhr = new XMLHttpRequest();
            const url = `${documentViewerConfig.documentsApiUrl.endsWith('/') ? documentViewerConfig.documentsApiUrl : documentViewerConfig.documentsApiUrl + '/'}documents/upload`;
            if (progressPrc) {
                xhr.upload.onprogress = (e) => {
                    if (e.lengthComputable) {
                        const prc = Math.round((e.loaded / e.total) * 100);
                        progressPrc(prc);
                    }
                };
            }
            xhr.onload = () => {
                if (xhr.status === 200) {
                    let fileId = '';
                    let status = '';
                    try {
                        const msg = JSON.parse(xhr.response);
                        fileId = _.get(msg, 'message', '');
                        status = _.get(msg, 'status', '');
                    } catch (ex) {
                        console.error(ex);
                    }
                    resolve([status !== 'error', fileId]);
                } else {
                    try {
                        const resp = JSON.parse(xhr.response);
                        if (resp.hasOwnProperty('detail')) resolve([false, resp.detail]);
                        else resolve([false, xhr.statusText]);
                    } catch (ex) {
                        console.log(ex);
                        resolve([false, xhr.statusText]);
                    }
                }
            };
            xhr.open('POST', url);
            const token = window.keycloak ? window.keycloak.token : window.auth.token;
            xhr.setRequestHeader('Authorization', `Bearer ${token}`);
            xhr.send(formData);
        });
    }

    static async getDocument(docId, signal = null) {
        return new Promise(function (resolve, reject) {
            axios
                .get(
                    `${documentViewerConfig.documentsApiUrl.endsWith('/') ? documentViewerConfig.documentsApiUrl : documentViewerConfig.documentsApiUrl + '/'}documents/${docId}/`,
                    {
                        signal,
                    },
                )
                .then(function (response) {
                    if (response.status === 200) {
                        resolve(response.data);
                    } else {
                        resolve(null);
                    }
                })
                .catch(function (error) {
                    reject(error);
                });
        });
    }

    /*private*/
    static getDocImageRequest = (docId, page, quality, signal = null) => {
        return new Promise(function (resolve, reject) {
            axios
                .get(
                    `${documentViewerConfig.documentsApiUrl.endsWith('/') ? documentViewerConfig.documentsApiUrl : documentViewerConfig.documentsApiUrl + '/'}documents/image/${docId}/${quality}${page}`,
                    {
                        signal,
                        responseType: 'blob',
                        mode: 'no-cors',
                        headers: { 'Access-Control-Allow-Origin': '*' },
                    },
                )
                .then(function (response) {
                    if (response.status === 200) {
                        resolve(response.data);
                    } else {
                        resolve(null);
                    }
                })
                .catch(function (error) {
                    reject(error);
                });
        });
    };

    static async getDocThumbnail(docId, signal = null) {
        return this.getDocImageRequest(docId, 1, 'LO', signal);
    }
    static async getDocPageThumbnail(docId, page, signal = null) {
        return this.getDocImageRequest(docId, page, 'LO', signal);
    }
    static async getDocPage(docId, page, signal = null) {
        return this.getDocImageRequest(docId, page, 'HI', signal);
    }

    static async getDocData(docId, signal = null) {
        return new Promise(function (resolve, reject) {
            axios
                .get(
                    `${documentViewerConfig.documentsApiUrl.endsWith('/') ? documentViewerConfig.documentsApiUrl : documentViewerConfig.documentsApiUrl + '/'}documents/data/${docId}`,
                    {
                        signal,
                    },
                )
                .then(function (response) {
                    if (response.status === 200) {
                        resolve(response.data);
                    } else {
                        resolve(null);
                    }
                })
                .catch(function (error) {
                    reject(error);
                });
        });
    }

    static async getDocAnnotations(docId, signal = null) {
        return new Promise(function (resolve, reject) {
            axios
                .get(
                    `${documentViewerConfig.documentsApiUrl.endsWith('/') ? documentViewerConfig.documentsApiUrl : documentViewerConfig.documentsApiUrl + '/'}documents/${docId}/annotations`,
                    {
                        signal,
                    },
                )
                .then(function (response) {
                    if (response.status === 200) {
                        resolve(response.data);
                    } else {
                        resolve(null);
                    }
                })
                .catch(function (error) {
                    reject(error);
                });
        });
    }
}
